// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kl-0";